module.exports = __webpack_public_path__ + "static/media/logo.d1e8c2bf.svg";